import React from "react";
import { AlertTriangle } from "lucide-react";
import { staleReason } from "../../lib/freshness";

/**
 * FMP-AN-009: a device whose data is older than the freshness threshold, or that
 * has never reported, is flagged and never presented as current compliance.
 *
 * Rendered IN PLACE of the status / compliance pill when the service marks a
 * record stale. The last known value stays visible underneath, labelled as such,
 * so the operator sees both what was last reported and that it is not current.
 * Amber, never green: it must not read as verified compliant.
 */
export function StaleBadge({ device, lastKnown, size = "sm" }) {
  const reason = staleReason(device);
  const pill = size === "lg"
    ? "text-sm px-4 py-1.5"
    : "text-xs px-3 py-1";
  return (
    <span
      className="inline-flex flex-col items-start gap-0.5"
      title={`Stale data: ${reason}. Last known status: ${lastKnown || "-"}. Not current compliance.`}
      data-stale
    >
      <span className={`inline-flex items-center gap-1.5 font-semibold rounded-full border border-amber-400 text-amber-700 bg-amber-50 ${pill}`}>
        <AlertTriangle className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
        Stale
      </span>
      <span className="text-[11px] leading-4 text-slate-500">
        {reason} · last known: {lastKnown || "-"}
      </span>
    </span>
  );
}
